import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { SpondService } from './services/SpondService';
import { createI18n } from 'vue-i18n';
import { messages } from './messages';

let previousSelectedLanguage = localStorage.getItem('locale');

if (!previousSelectedLanguage) {
  console.log('set language based on domain: ' + window.location.hostname);
  if (window.location.hostname.toLowerCase().endsWith('.no')) {
    previousSelectedLanguage = 'no';
  } else {
    previousSelectedLanguage = 'en';
  }
} else {
  console.log('set language based on previous selection');
}

const i18n = createI18n({
  locale: previousSelectedLanguage || 'en', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages // set locale messages
});

createApp(App)
  .use(router)
  .use(i18n)
  .provide('SpondService', new SpondService())
  .mount("#app");


